// @flow
import type { Epic } from '../../annotations';
import type { SendAnalytics } from '../../core/ga';

import * as r from 'ramda';
import { select } from 'redux-most';
import * as signals from '../signals';
import * as mostc from '../../crosscutting/mostc';
import { Hook } from '../../core/constants';

const transferDomainEpic = (
  sendAnalytics: SendAnalytics,
): Epic => r.pipe(
  select(signals.TRANSFER),
  mostc.map(({
    payload: {
      fqdn,
    },
  }) => {
    sendAnalytics({
      hitType: 'event',
      eventCategory: 'Basket',
      eventAction: 'transfer',
      // eventLabel: payload.fqdn,
    });

    return signals.emit(Hook.TRANSFER, { fqdn });
  }),
);

export default transferDomainEpic;
